import * as React from 'react';

import { useRetracked } from 'js/lib/retracked';

import { InlineNotification } from '@coursera/cds-core';

import storageUtils from 'bundles/enterprise-legacy-learner-home/utils/storageUtils';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/program-home';

export type Props = {
  userId: number;
  thirdPartyOrganizationId: string;
};

const COOKIE_KEY = 'MultiProgramSkillsetWarningBanner';
const notificationTrackingName = 'multi_program_warning_notification';

const setNotificationDismissed = (userId: number, thirdPartyOrganizationId: string) => {
  storageUtils.set(userId, thirdPartyOrganizationId, COOKIE_KEY, true);
};

const getNotificationDismissed = (userId: number, thirdPartyOrganizationId: string) => {
  return storageUtils.get(userId, thirdPartyOrganizationId, COOKIE_KEY, false);
};

export const MultiProgramSkillsetWarningBanner = ({ userId, thirdPartyOrganizationId }: Props) => {
  const trackComponent = useRetracked();
  const [isDismissed, setIsDismissed] = React.useState(() =>
    getNotificationDismissed(userId, thirdPartyOrganizationId)
  );

  const onDismissClick = () => {
    setIsDismissed(true);
    setNotificationDismissed(userId, thirdPartyOrganizationId);
    trackComponent({
      trackingData: { userId, thirdPartyOrganizationId },
      trackingName: notificationTrackingName,
      action: 'dismissed',
    });
  };

  if (isDismissed) {
    return null;
  }

  return (
    <TrackedDiv
      className="warning_notification"
      trackingName={notificationTrackingName}
      withVisibilityTracking={true}
      data={{ userId, thirdPartyOrganizationId }}
      data-testid="multi-program-skillset-warning-banner"
    >
      <InlineNotification
        severity="information"
        title={_t('SkillSets from all learning programs')}
        onDismiss={onDismissClick}
      >
        {_t('On this page, you can view SkillSets from all your learning programs.')}
      </InlineNotification>
    </TrackedDiv>
  );
};

export default MultiProgramSkillsetWarningBanner;
